const objectFitImages = require('object-fit-images');
const Flickity = require('flickity');

require ('flickity-imagesloaded');
require('./components/calendar.js');

(function($) {

	const hoogeland = {};

	hoogeland.hamburgerMenu = () => {
		$('.hamburger').on('click', function(){
			$('body').toggleClass('menu-active');

			$(this).toggleClass('is-active');
			$('.nav-mobile').toggleClass('open');
		});
	}

	hoogeland.newsCarousel = () => {
		let $newsCarousel = $('.news-carousel');
		$newsCarousel.each(function(i, e) {
			new Flickity(e, {
				pageDots: false,
				wrapAround: false,
				draggable: false,
				watchCSS: true,
				prevNextButtons: true,
				cellAlign: 'left',
				imagesLoaded: true,
			});
		});
	}

	hoogeland.gformTextarea = () => {
		$('#input_1_3').on('input', function () {
			this.setAttribute('rows', '1');
			this.setAttribute('style', 'min-height: 50px');
			this.style.height = 'auto';
            this.style.height = (this.scrollHeight) + 'px';
        });
	}


	hoogeland.gformLoaded = () => {
		$(document).on('gform_confirmation_loaded', function(e, formId) {
			e.preventDefault();
			if(formId == 1) {
				$('#contact-gform').addClass('form-submitted');
			}
		});
	}

	hoogeland.init = function() {
		hoogeland.hamburgerMenu();
		hoogeland.newsCarousel();
		hoogeland.gformLoaded();
		hoogeland.gformTextarea();
	}

	hoogeland.init();

	$(document).ready(function(){
		$('body').trigger('bless');
		objectFitImages();
    });



})(jQuery);
